export const getDelay = (ms:number) => new Promise((resolve, _) => setTimeout(resolve, ms));